import React, { useState,useEffect } from 'react'
import swal from 'sweetalert';
import Select from 'react-select';
import Axios from "axios";


export default function Adduser(props) {
    /*const [items, setitems] = useState({ f_name: "", l_name: "", username: "", password: "", email: "", phone: "", discount: 0, company_id: props.companyid, usertypeid: "" })*/
    const [items, setitems] = useState({ f_name: "", l_name: "", username: "", password: "",repassword:"", company_id: props.companyid, usertypeid: "" })
    const [type, settype] = useState([])
    const [typevalue, settypevalue] = useState();
    useEffect(() => {
        fetchUsertype();
    }, [])
    async function fetchUsertype() {
        var res = await Axios.get(process.env.REACT_APP_APIURL + "User/GetUsertypes")
       
        var type = [];
        res.data.map((u) => {
            type.push({ value: u.id, label: u.name });
        })
        settype(type)
    }
    const handleInput = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setitems({ ...items, [name]: value })
    }
    const refresh = () => {
        settypevalue(null)
        /*setitems({ f_name: "", l_name: "", username: "", password: "", email: "", phone: "", discount: 0, company_id: props.companyid, usertypeid: "" });*/
        setitems({ f_name: "", l_name: "", username: "", password: "", repassword: "", company_id: props.companyid, usertypeid: "" });
    }
    const savemethod = async (data) => {
        const url = process.env.REACT_APP_APIURL + "User/Adduser";
        await fetch(url, {
            method: "POST",
            headers: {
                'Accept': "json",
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(res => {
            debugger;
            if (res.status == 200) {
                swal({
                    title: "Saved Successfully",
                    icon: "success"
                })
                refresh();

            }
            else if (res.status == 404) {
                swal({
                 
                    title: "Sorry!",
                    text: "You can't use this username and password because it conflicts with another account.",
                    icon: "warning",
                })
                refresh();

            }
        })
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Disable the submit button
        const submitButton = e.target.querySelector('button[type="submit"]');
        submitButton.disabled = true;
      
        // Show loader on the button
        submitButton.innerHTML = '<section><span class="loader-5"></span></section>';
      
        try {
          if (items.usertypeid === "") {
            swal({
              title: "Usertype Required!",
              icon: "error"
            });
            return;
          }
      
          if (items.repassword !== items.password) {
            swal({
              title: "Password and Confirm Password do not match!",
              icon: "error"
            });
            return;
          }
      
          items.company_id = props.companyid;
      
          await savemethod(items);
          // Reset the form
          // ...
      
          // Show success message
          swal({
            title: "Form submitted successfully!",
            icon: "success"
          });
        } catch (error) {
          // Show error message
          swal({
            title: "An error occurred!",
            text: error.message,
            icon: "error"
          });
        } finally {
          // Enable the submit button
          submitButton.disabled = false;
          // Reset the button text
          submitButton.innerHTML = "Submit";
        }
      };
      
    return (
        <div className="row">
            <div className="col-12 col-md-12">
                <div className="card">
                    <div className="card-header">
                        <h3 className="me-auto mb-3 mt-5 text-center mx-auto">Add User</h3>
                    </div>
                    <div className="card-body">

                        <div className="basic-form">
                            <form action="" onSubmit={handleSubmit}>
                                <div className="row flex-column align-items-center">
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">First Name *</label>
                                        <input type="text" className="form-control" name="f_name" autoComplete="off" value={items.f_name} onChange={handleInput} required />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">Last Name</label>
                                        <input type="text" className="form-control" name="l_name" autoComplete="off" value={items.l_name} onChange={handleInput} />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">Username *</label>
                                        <input type="text" className="form-control" name="username" autoComplete="off" value={items.username} onChange={handleInput} required />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">Passoword *</label>
                                        <input type="text" className="form-control" name="password" autoComplete="off" value={items.password} onChange={handleInput} required />
                                    </div>
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label className="form-label">Confirm Passoword *</label>
                                        <input type="text" className="form-control" name="repassword" autoComplete="off" value={items.repassword} onChange={handleInput} required />
                                    </div>
                                    {/*<div className="mb-3 col-sm-6 col-lg-6">*/}
                                    {/*    <label className="form-label">Email</label>*/}
                                    {/*    <input type="email" className="form-control" name="email" autoComplete="off" value={items.email} onChange={handleInput}  />*/}
                                    {/*</div>*/}
                                    {/*<div className="mb-3 col-sm-6 col-lg-6">*/}
                                    {/*    <label className="form-label">Phone</label>*/}
                                    {/*    <input type="number" className="form-control" name="phone" autoComplete="off" value={items.phone} onChange={handleInput}  />*/}
                                    {/*</div>*/}
                                    {/*<div className="mb-3 col-sm-6 col-lg-6">*/}
                                    {/*    <label>Discount(%)</label>*/}
                                    {/*    <input type="number" className="form-control" name="discount" autoComplete="off" value={items.discount} onChange={handleInput} />*/}
                                    {/*</div>*/}
                                    <div className="mb-3 col-sm-6 col-lg-6">
                                        <label>User Type *</label>
                                        <Select options={type} value={typevalue} onChange={(e) => { settypevalue(e); setitems({ ...items, usertypeid: e.value }) }} />
                                    </div>
                                </div>
                                <button type="submit" className="d-flex mx-auto btn btn-primary">Save</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}